const DOCUMENT = 'TALENT_CONVERSION_RULES_';

const actions = {
  LOAD_FORM_DATA: DOCUMENT + 'LOAD_FORM_DATA',
  LOAD_FORM_DATA_SUCCESS: DOCUMENT + 'LOAD_FORM_DATA_SUCCESS',
  EDIT: DOCUMENT + 'EDIT',
  EDIT_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  UPDATE: DOCUMENT + 'UPDATE',
  UPDATE_SUCCESS: DOCUMENT + 'UPDATE_SUCCESS',
  TOUCH: DOCUMENT + 'TOUCH',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  CHANGE_FILTERED_UNITS: DOCUMENT + 'CHANGE_FILTERED_UNITS',
  CHANGE_SELECTED_UNITS: DOCUMENT + 'CHANGE_SELECTED_UNITS',
  SAVE_ERROR: DOCUMENT + 'SAVE_ERROR',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',

  loadFormData: data => ({ type: actions.LOAD_FORM_DATA, payload: data }),
  loadFormDataSuccess: data => ({ type: actions.LOAD_FORM_DATA_SUCCESS, payload: data }),
  edit: data => ({ type: actions.EDIT, payload: data }),
  editSuccess: data => ({ type: actions.EDIT_SUCCESS, payload: data }),
  update: data => ({ type: actions.UPDATE, payload: data }),
  updateSuccess: () => ({ type: actions.UPDATE_SUCCESS }),
  touch: data => ({ type: actions.TOUCH, payload: data }),
  changeProperty: data => ({ type: actions.CHANGE_PROPERTY, payload: data }),
  changeFilteredUnits: data => ({ type: actions.CHANGE_FILTERED_UNITS, payload: data }),
  changeSelectedUnits: data => ({ type: actions.CHANGE_SELECTED_UNITS, payload: data }),
  saveError: data => ({ type: actions.SAVE_ERROR, payload: data }),
  clearStore: () => ({ type: actions.CLEAR_STORE }),
};

export default actions;
